import React, { useEffect, useReducer } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

// CSS
import styles from '@UILayer/UILayer.scss';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getGlobalStyles } from '@Managers/Redux/AppState/AppState';
import { getReconnectNotification } from '@Managers/Redux/HttpState';

//IMAGES
import { ReconnectIcon } from './ReconnectNotificator.icon';
import { Button } from '@UILayer/Inputs/Button';

const ReconnectNotificator: React.FC<{}> = () => {
    const [state, setState] = useReducer((state: { text: string; reloadBtn: false }, newState: any) => ({ ...state, ...newState }), {
        text: '',
        reloadBtn: false
    });
    const { t } = useTranslation();
    const globalStyles = useAppSelector(getGlobalStyles);
    const reconnectData = useAppSelector(getReconnectNotification);
    const classes = cn(styles.reconnect_notificator_container, globalStyles.orientation);

    useEffect(() => {
        if (reconnectData.active) {
            let text = t('RECONNECT_MESSAGE_RETRY_NOTIFICATION');
            let reloadBtn = false;

            if (reconnectData.tryAttepmt !== reconnectData.maxTries) {
                text = text.replace('%try', JSON.stringify(reconnectData.tryAttepmt)).replace('%max_try', JSON.stringify(reconnectData.maxTries));
            } else {
                reloadBtn = true;
                text = t('RECONNECT_MESSAGE_RETRY_NOTIFICATION_LIMIT');
            }

            setState({ text: text, reloadBtn: reloadBtn });
        }
    }, [reconnectData]);

    function appReload() {
        window.location.reload();
    }

    return (
        <>
            {reconnectData.active && (
                <div className={classes}>
                    <div className={styles.reconnect_icon}>
                        <ReconnectIcon />
                    </div>
                    <div className={styles.reconnect_description}>
                        <div dangerouslySetInnerHTML={{ __html: state.text }}></div>
                        {state.reloadBtn && (
                            <Button
                                id={`app_relaod_button`}
                                description={''}
                                className={cn(styles.reconnect_reload_button)}
                                onChange={() => appReload()}
                                dataDismiss="modal"
                            >
                                {t('RECONNECT_MESSAGE_RETRY_NOTIFICATION_RELOAD_BTN')}
                            </Button>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default ReconnectNotificator;

//
/*

dangerouslySetInnerHTML={{
                            __html: (
                                <>
                                    {state.text}
                                    {state.reloadBtn && (
                                        <Button
                                            id={`app_relaod_button`}
                                            description={''}
                                            className={cn(styles.reconnect_reload_button)}
                                            onChange={() => appReload()}
                                            dataDismiss="modal"
                                        >
                                            {t('RECONNECT_MESSAGE_RETRY_NOTIFICATION_RELOAD_BTN')}
                                        </Button>
                                    )}
                                </>
                            )
                        }}
*/
